import { PlayersTable } from '../components/PlayersTable'
import { Player } from '../assets/data'
interface HomeProps {
  players: Player[]
}
function Home({ players }: HomeProps) {
  return (
    <div>
      <h3>Rock Stats and History</h3>
      <p>The complete source for current and historical rock players, scores and leaders.</p>
      <PlayersTable players={players} />
    </div>
  )
}

export default Home
